import { IConfiguration } from 'configuration/config.types';
import { useInjection } from 'inversify-react';

export const useConfiguration = (): IConfiguration => {
  const config = useInjection(IConfiguration.$);
  return config;
};
